var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.currentField.label,"label-width":_vm.currentField.labelWidth + 'px'}},[_c('el-date-picker',_vm._b({attrs:{"type":"date","placeholder":"Pick a day"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},'el-date-picker',_vm.attributesBinding,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }